import { SimulacaoPrice } from '@/domain/simulador/factories/concrete/horizontal/price/simulacao-price'
import { SimulacaoSacocH } from '@/domain/simulador/factories/concrete/horizontal/sacoch/simulacao-sacoch'
import { SimulacaoSacocVParcelado } from '@/domain/simulador/factories/concrete/horizontal/sacocv/simulacao-sacocv-parcelado'
import { SimulacaoSacocVSaldo } from '@/domain/simulador/factories/concrete/horizontal/sacocv/simulacao-sacocv-saldo'
import { SimulacaoVertical } from '@/domain/simulador/factories/concrete/vertical/simulacao-vertical'
import type { TFormaDePagamentoEnum, TTipoAmortizacaoEnum } from '@/types/simulacao'

export class SimulacaoFactory {
  static create(
    tipoAmortizacao?: TTipoAmortizacaoEnum | null,
    formaPagamento?: TFormaDePagamentoEnum | null,
  ): SimulacaoSacocVParcelado | SimulacaoSacocVSaldo | SimulacaoSacocH | SimulacaoPrice | SimulacaoVertical {
    switch (tipoAmortizacao) {
      case 'SacocV':
        return formaPagamento === 'Parcelado' ? new SimulacaoSacocVParcelado() : new SimulacaoSacocVSaldo()

      case 'SacocH':
        return new SimulacaoSacocH()

      case 'Price':
        return new SimulacaoPrice()

      default:
        return new SimulacaoVertical()
    }
  }
}
